import script from "./SurveyInternalAuditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyInternalAuditor.vue?vue&type=script&setup=true&lang=js"

import "./SurveyInternalAuditor.vue?vue&type=style&index=0&id=56124826&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56124826"]])

export default __exports__